// import { StoreDetailsCard } from '../storeDetailsCard';
import Typography from '../Typography/Typography';
import styles from './style.module.css';

interface IScrollableContainerProps {
  containername?: string;
  children?: React.ReactNode;
}

export const GridContainer: React.FC<IScrollableContainerProps> = ({ containername = '', children }) => {
  return (
    <div className={styles.container}>
      <div><Typography className={styles.header}>{containername}</Typography></div>
      <div className={styles.contentContainer}>{children}</div>
    </div>
  );
};
